import { DASHBOARD_COLORS } from '../dashboardStyles';

export const SALES_OVERVIEW_TEMPLATE_IDS = ['template1', 'template2', 'template3'];

export const SALES_OVERVIEW_TEMPLATES = [
  {
    id: 'template1',
    label: 'Template 1',
    description: 'Area chart with KPI summary row',
  },
  {
    id: 'template2',
    label: 'Template 2',
    description: 'Bar chart with colored metric cards',
  },
  {
    id: 'template3',
    label: 'Template 3',
    description: 'Line chart with side metric panel',
  },
];

/** Sample data for settings previews (non-interactive). */
export const SAMPLE_SALES_OVERVIEW = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  data: [42000, 55000, 48000, 62000, 58000, 71000],
  metrics: {
    primary: 71000,
    secondary: 58000,
    dailyAverage: 2367,
  },
};

export const SALES_OVERVIEW_PERIODS = ['monthly', 'weekly'];

export const getSalesOverviewKpiConfig = (period = 'monthly') => {
  const isWeekly = period === 'weekly';
  return [
    {
      key: 'primary',
      label: isWeekly ? 'This Week' : 'This Month',
      color: DASHBOARD_COLORS.sales,
    },
    {
      key: 'secondary',
      label: isWeekly ? 'Last Week' : 'Last Month',
      color: DASHBOARD_COLORS.text,
    },
    {
      key: 'dailyAverage',
      label: 'Daily Average',
      color: '#2563eb',
    },
  ];
};

/** @deprecated Use getSalesOverviewKpiConfig */
export const KPI_CONFIG = getSalesOverviewKpiConfig('monthly');

export const buildBaseChartOptions = (labels) => ({
  chart: {
    toolbar: { show: false },
    zoom: { enabled: false },
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  },
  dataLabels: { enabled: false },
  grid: {
    borderColor: DASHBOARD_COLORS.border,
    strokeDashArray: 4,
  },
  xaxis: {
    categories: labels,
    labels: { style: { colors: DASHBOARD_COLORS.textMuted, fontSize: '11px' } },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: {
    labels: {
      style: { colors: DASHBOARD_COLORS.textMuted, fontSize: '11px' },
      formatter: (v) => {
        const n = Number(v);
        if (n >= 1000) return `₹${(n / 1000).toFixed(0)}K`;
        return `₹${n.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
      },
    },
  },
});
